import Http from '../Http'
import { IQuery } from '../interfaces/Query'
import { IToken } from '../interfaces/Token'
import { Routes } from '../routes'

export default class Report extends Http {
  public async performances(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.performancesReportPath(),
      token,
      params,
    )) as any
  }
  public async sales(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.salesReportPath(),
      token,
      params,
    )) as any
  }

  public async products(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.productsReportPath(),
      token,
      params,
    )) as any
  }

  public async consignments(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.consignmentsReportPath(),
      token,
      params,
    )) as any
  }

  public async salesOld(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.salesOldReportPath(),
      token,
      params,
    )) as any
  }
}
